import { useEffect, useMemo, useState } from "react";
import OpportunityCard from "@/app/global-components/opportunity-card";
// import NavPage from "../nav/nav-page";
//import { MultiSelect } from "@/app/global-components/multi-select";
import { isUndefined } from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import {
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG, ROLE } from "@/types";
import Footer from "@/layouts/footer";
import NavPage from "@/layouts/nav-header";
import { SearchIcon } from "lucide-react";
import useOffer from "@/hooks/useTender";
import { cn } from "@/lib/utils";

// Define the type for category options
interface CategoryOption {
  value: any; // Use specific types here, like string or number, if known
  label: any; // Use string if label is always a string
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const TenderPage = ({ isLog }: { isLog: boolean }) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [visibleCards, setVisibleCards] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategories, setFilterCategories] = useState<string[] | string>(
    []
  );
  const [filteredOpportunities, setFilteredOpportunities] = useState<any[]>([]);
  const [opportunities, setOpportunities] = useState<any[]>([]);

  const [Categoris, setCategoris] = useState<CategoryOption[]>([]);

  const { getOffers, getcategories } = useOffer();
  const authUser = useSelector((state: RootState) => state.auth.authUser);

  const userRole = isUndefined(authUser?.role) ? "" : authUser?.role;

  const isSeller = userRole == ROLE.SELLER;
  const Main = () => {
    return (
      <div
        className={cn("container mx-auto p-6 ",isSeller?"":'mt-20 md:mt-40')}
        style={{ overflow: "auto" }}
      >
        <div className="mb-6 flex flex-col items-center md:items-start text-right">
          <Typography variant="h5" className="!font-bold" gutterBottom>
            {t("navigation.AvailableOpportunitiesList")}
          </Typography>
        </div>
        <div className="flex flex-col md:justify-between md:flex-row md:items-center mb-6 gap-4">
          <TextField
            label={t("actions.search")}
            variant="outlined"
            fullWidth
            dir={locale === LANG.AR ? "rtl" : "ltr"}
            margin="normal"
            value={searchTerm}
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
              inputProps: { dir: locale === LANG.AR ? "rtl" : "ltr" },
            }}
            sx={{
              maxWidth: 300,
              "& .MuiInputBase-root": {
                direction: locale === LANG.AR ? "rtl" : "ltr",
              },
              "& .MuiInputLabel-root": {
                transformOrigin: locale === LANG.AR ? "right" : "left",
                direction: locale === LANG.AR ? "rtl" : "ltr",
                // right: locale === LANG.AR ? 30 : "auto",
                // left: locale === LANG.EN ? 0 : "auto",
                ...(locale === LANG.AR
                  ? { right: 30, left: "auto" }
                  : { left: 0, right: "auto" }),
              },
              "& legend": {
                textAlign: locale === LANG.AR ? "end" : "start",
              },
            }}
          />
          <Select
            displayEmpty
            id="categorie-multiple-name"
            input={<OutlinedInput />}
            inputProps={{ "aria-label": "Without label" }}
            className="h-10 bg-white w-36 md:w-64 xl:w-80 border !border-zinc-500"
            multiple
            sx={{
              "& .MuiSelect-select": {
                paddingRight: "10px !important",
              },
              "& .MuiSelect-icon": {
                left: locale === LANG.EN ? "unset" : 0,
                marginLeft: 0,
                right: locale === LANG.EN ? 0 : "unset",
              },
            }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>{t("categories.select")}</em>;
              }
              const value = Categoris.filter((value) =>
                selected.includes(value.value)
              ).map((item) => item.label);
              return value.join(", ");
            }}
            value={filterCategories}
            onChange={(e) => setFilterCategories(e.target.value)}
            MenuProps={MenuProps}
          >
            <MenuItem disabled value="">
              <em>{t("categories.select")}</em>
            </MenuItem>
            {Categoris.map((name) => (
              <MenuItem
                className="!mb-2"
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#000",
                    borderRadius: 15,
                    color: "#fff",
                    fontWeight: "600",
                  },
                  "&:hover.MuiMenuItem-root": {
                    backgroundColor: "#000",
                    borderRadius: 15,
                    color: "#fff",
                  },
                }}
                key={name.value}
                value={name.value}
                // style={getStyles(name, personName, theme)}
              >
                <span>{name.label}</span>
              </MenuItem>
            ))}
          </Select>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredOpportunities.slice(0, visibleCards).map((opportunity) => (
            <OpportunityCard key={opportunity.id} opportunity={opportunity} />
          ))}
        </div>
      </div>
    );
  };
  useEffect(() => {
    const fetchCategoris = async () => {
      try {
        const Categories = await getcategories();
        if (Categories) {
          const uniqueCategories = Categories.data.filter(
            (item: { name: any }, index: any, self: any[]) =>
              index === self.findIndex((t) => t.name === item.name) // Only keep unique ids
          );
          const Cates: CategoryOption[] = uniqueCategories.map(
            (item: { id: any; name: any }) => ({
              value: item.id,
              label: item.name,
            })
          );
          setCategoris(Cates);
        } else {
          setCategoris([]);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };
    fetchCategoris();
  }, []);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const Offers = await getOffers("Opened");
        if (Offers) {
          setOpportunities(Offers.data);
        } else {
          setOpportunities([]);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };

    fetchOffers();
  }, []);

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight
    ) {
      setVisibleCards((prevVisibleCards) => prevVisibleCards + 10);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useMemo(() => {
    const lowercasedSearchTerm = searchTerm.toLowerCase();
    const filtered = opportunities.filter(
      (opportunity) =>
        opportunity.title.toLowerCase().includes(lowercasedSearchTerm) &&
        (filterCategories.length === 0 ||
          opportunity.categories.some((category: string) =>
            filterCategories.includes(category)
          ))
    );
    setFilteredOpportunities(filtered);
  }, [searchTerm, filterCategories, opportunities]);
  
 

  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#f8fafa !important" }}
    >
      {!isLog ? (
        <NavPage isForm={0}>
          <Main />
        </NavPage>
      ) : (
        <Main />
      )}
      {!isSeller && <Footer />}
    </div>
  );
};

export default TenderPage;
